import useOnSnapshot from 'components/useOnSnapshot';

const useCustomers = () => {
  const { data, isLoading } = useOnSnapshot('customers');

  return { customers: data, isLoading };
};

export default useCustomers;
